<template>
  <div v-if="actors.length || post.casting" class="casting-section glass-card pa-6 mb-6">
    <div class="d-flex align-center ga-2 mb-4">
      <v-icon color="primary" size="22">mdi-account-group-outline</v-icon>
      <h3 class="text-subtitle-1 font-weight-bold mb-0">Cast & Characters</h3>
    </div>

    <!-- Actor Photo Cards Carousel -->
    <div v-if="actors.length" class="casting-scroll">
      <div v-for="actor in actors" :key="actor.key" class="casting-card">
        <div class="casting-card__photo-wrap">
          <v-img
            v-if="actor.photo"
            :src="actor.photo"
            aspect-ratio="2/3"
            cover
            class="casting-card__image"
          >
            <template #placeholder>
              <div class="casting-card__placeholder">
                <v-icon size="32" color="primary">mdi-account</v-icon>
              </div>
            </template>
          </v-img>
          <div v-else class="casting-card__placeholder">
            <v-icon size="32" color="primary">mdi-account</v-icon>
          </div>
        </div>
        <div class="casting-card__name text-truncate font-weight-bold mt-2">{{ actor.name }}</div>
      </div>
    </div>

    <!-- Full Cast Text Fallback / Supplemental -->
    <div v-if="post.casting" class="mt-4 pt-3 border-t-subtle">
      <div class="text-caption text-medium-emphasis font-weight-medium mb-1">Additional Cast:</div>
      <p class="text-body-2 mb-0 text-medium-emphasis">{{ post.casting }}</p>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'MovieCasting',
  props: {
    post: { type: Object, required: true },
  },
  setup(props) {
    const actors = computed(() => {
      const list = []
      for (let n = 1; n <= 6; n += 1) {
        const name = props.post[`actorname${n}`]
        const photo = props.post[`actorpix${n}`]
        if (name || photo) {
          list.push({ key: n, name: name || 'Actor', photo })
        }
      }
      return list
    })

    return { actors }
  },
}
</script>

<style scoped>
.casting-scroll {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: thin;
}

.casting-card {
  flex: 0 0 110px;
  text-align: center;
}

.casting-card__photo-wrap {
  width: 100%;
  aspect-ratio: 2 / 3;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  background: rgba(128, 128, 128, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.casting-card:hover .casting-card__photo-wrap {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.casting-card__image {
  width: 100%;
  height: 100%;
}

.casting-card__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(99, 102, 241, 0.1);
}

.casting-card__name {
  font-size: 0.8rem;
  line-height: 1.2;
}

.border-t-subtle {
  border-top: 1px solid rgba(128, 128, 128, 0.1);
}
</style>

